// extracted by mini-css-extract-plugin
export default {"uzi":"Home_uzi__RcRtd","content":"Home_content__iQaRh","home":"Home_home__gFokM","intro":"Home_intro__PFFWf","intro2":"Home_intro2__rm3Bg","underline":"Home_underline__xzO0h"};